import { render, staticRenderFns } from "./FieldComponent.vue?vue&type=template&id=2fbc8744&scoped=true"
import script from "./FieldComponent.vue?vue&type=script&lang=js"
export * from "./FieldComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbc8744",
  null
  
)

export default component.exports